import { CalendarCheck2 } from "lucide-react";
import { useState } from "react";
import { API } from "../data/siteData";

const initialForm = {
  full_name: "",
  email: "",
  company: "",
  phone: "",
  briefing_type: "30-minute investor conversation",
  topic: "Investment discussion",
  message: "",
  consent: false,
};

export default function BriefingRequestForm() {
  const [form, setForm] = useState(initialForm);
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");

  const update = (field, value) => setForm({ ...form, [field]: value });

  const submit = async (event) => {
    event.preventDefault();
    setState("loading");
    setError("");
    try {
      const response = await fetch(`${API}/briefing-requests`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!response.ok) throw new Error();
      setState("success");
    } catch {
      setState("error");
      setError("Your briefing request could not be sent. Please try again.");
    }
  };

  if (state === "success") {
    return <div className="form-success" data-testid="briefing-request-success"><CalendarCheck2 size={27} /><span>REQUEST RECEIVED</span><h2>WE’LL COORDINATE THE NEXT STEP.</h2><p>A GAMEDAY representative will review your request and follow up directly.</p></div>;
  }

  return (
    <form className="lead-form" onSubmit={submit} data-testid="briefing-request-form">
      <span className="eyebrow">Executive briefing request</span>
      <h2>START A PRIVATE CONVERSATION.</h2>
      <div className="form-grid">
        <label>Full name<input required value={form.full_name} onChange={(event) => update("full_name", event.target.value)} data-testid="briefing-full-name-input" /></label>
        <label>Email<input required type="email" value={form.email} onChange={(event) => update("email", event.target.value)} data-testid="briefing-email-input" /></label>
        <label>Organization<input value={form.company} onChange={(event) => update("company", event.target.value)} data-testid="briefing-company-input" /></label>
        <label>Phone<input value={form.phone} onChange={(event) => update("phone", event.target.value)} data-testid="briefing-phone-input" /></label>
        <label>Conversation<select value={form.briefing_type} onChange={(event) => update("briefing_type", event.target.value)} data-testid="briefing-type-select"><option>15-minute introduction</option><option>30-minute investor conversation</option><option>45-minute strategic briefing</option><option>60-minute executive presentation</option></select></label>
        <label>Topic<input required value={form.topic} onChange={(event) => update("topic", event.target.value)} data-testid="briefing-topic-input" /></label>
      </div>
      <label>Context for the conversation<textarea value={form.message} onChange={(event) => update("message", event.target.value)} data-testid="briefing-message-input" /></label>
      <label className="check-label"><input required type="checkbox" checked={form.consent} onChange={(event) => update("consent", event.target.checked)} data-testid="briefing-consent-checkbox" />I agree to the privacy notice and consent to GAMEDAY contacting me.</label>
      {error && <p className="form-error" data-testid="briefing-request-error">{error}</p>}
      <button className="button button--red" disabled={state === "loading"} data-testid="briefing-request-submit-button">{state === "loading" ? "Sending request…" : "Request Executive Briefing"}</button>
    </form>
  );
}